// AppLink is the intentional boundary around React Router's Link component.
// eslint-disable-next-line no-restricted-imports
import { Link, useResolvedPath, type LinkProps } from 'react-router';
import { hasExternalFrameAncestor, isAccountRoutePathname } from '@/lib/accountFraming.mjs';

export type AppLinkProps = LinkProps;

/**
 * AppLink is a wrapper around React Router's Link component that sets
 * a default prefetch strategy of "intent" (prefetch on hover/focus).
 *
 * Use this for all internal navigation links unless you have a specific
 * reason to use a different prefetch strategy.
 */
const AppLink = (props: AppLinkProps) => {
  const { prefetch = 'intent', target, rel, ...rest } = props;
  const destination = useResolvedPath(rest.to, { relative: rest.relative });
  const openOutsideFrame =
    isAccountRoutePathname(destination.pathname) && hasExternalFrameAncestor();
  return (
    <Link
      {...rest}
      prefetch={openOutsideFrame ? 'none' : prefetch}
      target={openOutsideFrame ? '_blank' : target}
      rel={openOutsideFrame ? [rel, 'noopener'].filter(Boolean).join(' ') : rel}
    />
  );
};

export default AppLink;
